import { render, staticRenderFns } from "./FAQOddSalesComponent.vue?vue&type=template&id=30694cb4&scoped=true&"
import script from "./FAQOddSalesComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQOddSalesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQOddSalesComponent.vue?vue&type=style&index=0&id=30694cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30694cb4",
  null
  
)

export default component.exports